/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      enum: [
        'YES_INCLUDING_HAZARDOUS_SUBSTANCES',
        'YES_NOT_INCLUDING_HAZARDOUS_SUBSTANCES',
        'NO_NO_CHEMICALS_AND_NO_HAZARDOUS_SUBSTANCES',
      ],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_use_chemicals_andor_hazardous_substances: valueSchema,
  },
}
